import { FC, ReactNode } from 'react';
import { StatusQuery } from '@components/Queries/StatusQyery';
import { BackButton } from '@dynamika-shared/ui/BackButton/BackButton';
import { useNavigate } from 'react-router-dom';
import { QueryTicketDto } from '@restore/queries/queries.types';

type QueryHeaderProps = {
  query: QueryTicketDto;
  topRightControls?: ReactNode;
};

export const QueryHeader: FC<QueryHeaderProps> = ({
  query,
  topRightControls,
}) => {
  const navigate = useNavigate();
  return (
    <header className='pt-4.5 flex justify-between'>
      <div className='flex gap-1 items-center'>
        <BackButton action={() => navigate(-1)} />
        <h2 className='text-chineseBlack text-[36px] font-semibold flex items-center gap-1'>
          <span className='text-spanishGray text-[36px] font-semibold'>
            Query
          </span>
          {query?.queryNumber}
          <StatusQuery status={query?.status} />
        </h2>
      </div>
      {topRightControls}
    </header>
  );
};
